import { HubConnectionManager } from '@ygtechnologies/bygr-frontend-chat';

let nextId = 1;

type EventHandler = (...params: any[]) => any;
export default class HubSession {
    private handlers: { method: string; handler: EventHandler }[] = [];

    // protected readonly connection = connectionManagerInstance;

    _reconnectHandler = () => this.onReconnect();
    readonly id: number;

    constructor(connection: HubConnectionManager) {
        this.id = nextId++;
        this._connection = connection;

        this.connection.onReconnect.addHandler(this._reconnectHandler);
    }

    private readonly _connection: HubConnectionManager;
    get connection() {
        return this._connection;
    }

    // constructor() {
    //     this.connection.onOpenConnection().then(this.onConnect);
    // }

    onReconnect() {}

    onDispose() {}

    disposed = false;
    dispose() {
        if (!this.disposed) {
            this.onDispose();
        }

        this.connection.onReconnect.removeHandler(this._reconnectHandler);

        this.handlers.forEach((x) => {
            this.connection.off(x.method, x.handler);
        });

        this.disposed = true;
    }

    protected addHandler(method: string, handler: EventHandler): void {
        if (this.disposed) {
            throw new Error('Session is disposed');
        }
        this.connection.on(method, handler);
        this.handlers.push({ method, handler });
    }
}